import { defineMessages } from 'react-intl';

export default defineMessages({
  resultsPerPage: 'per page',
  pageRange: '{currentPage} of {formattedTotalPages}'
});
